import React, { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const BdTongIntm = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchGrdc: '',
        searchLoca: '',
        searchCheck1: '',
        searchCheck2: '',
        searchGubun: [],
    });

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newParams = {
            ...searchParams,
            [name]: type === 'checkbox' ? (checked ? "1" : "") : value,
        };
        setSearchParams(newParams);
    };

    const handleWeekdayChange = (e) => {
        const { value, checked } = e.target;
        let updated = [...searchParams.searchGubun];

        if (checked) {
            if (!updated.includes(value)) {
                updated.push(value);
            }
        } else {
            updated = updated.filter((val) => val !== value);
        }
        setSearchParams({
            ...searchParams,
            searchGubun: updated.sort(),
        });
    };

    const dataHead = ['의료기관명', '종별', '지역', '기관수', '전체환자수', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
    const dataColumn = ['TNAME', 'EMCTYPE', 'EMCLOCA', 'EMCCOUNT', 'RECCOUNT', 'TT1', 'TT2', 'TT3', 'TT4', 'TT5', 'TT6', 'TT7', 'TT8', 'TT9', 'TT10', 'TT11', 'TT12', 'TT13', 'TT14', 'TT15', 'TT16', 'TT17', 'TT18', 'TT19', 'TT20', 'TT21', 'TT22', 'TT23', 'TT24'];
    const apiCall = '/ptmiapi/tonggyeweb/bdtongintmlist.do';
    const apiCntCall = '';
    const searchParamsAdditional = {};
    const excelFileName = "내원시각별 환자수";
    const excelHead = [];
    const mergeConfig = [{ key: 'TNAME', row: null }, { key: 'EMCTYPE', row: 2, nullable: 'true' }, { key: 'EMCLOCA', row: 2, nullable: 'true' }, { key: 'EMCCOUNT', row: 2 }]

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    };

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    });

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0
    });

    const mergedSearchParams = {
        ...searchParams,
        searchGubun: searchParams.searchGubun.join('')
    };

    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width="25%" />
                        <col width="25%" />
                        <col width="25%" />
                        <col width="25%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={false}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>기&emsp;간</th>
                            <td>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />&nbsp;
                                ~
                                &nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                            <th>내원요일</th>
                            <td>
                                {[...Array(7)].map((_, idx) => {
                                    const value = (idx + 1).toString();
                                    const dayLabel = ['일', '월', '화', '수', '목', '금', '토'][idx];
                                    return (
                                        <span key={value}>
                                            <input
                                                type="checkbox"
                                                name="searchGubun"
                                                value={value}
                                                onChange={handleWeekdayChange}
                                                checked={searchParams.searchGubun.includes(value)}
                                            />{dayLabel}&nbsp;
                                        </span>
                                    );
                                })}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <div>
                                    <span>
                                        <input type="checkbox" id="searchCheck1" name="searchCheck1" checked={searchParams.searchCheck1 === '1'} onChange={handleInputChange} />
                                        <label htmlFor="searchCheck1">진료외 방문 (챠트복사, 경유를 위한 접수) 제외</label>
                                    </span>
                                    <span>
                                        <input type="checkbox" id="searchCheck2" name="searchCheck2" checked={searchParams.searchCheck2 === '1'} onChange={handleInputChange} />
                                        <label htmlFor="searchCheck2">실시간 데이터 기준</label>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={mergedSearchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
        </Main>
    );
};

export default BdTongIntm;
